import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "toggler"]

  toggle() {
    this.#details.open = !this.#details.open
    if (this.hasTogglerTarget) {
      this.#toggler.classList.toggle("tgl-btn--checked", this.#details.open)
    }
  }

  get #details() {
    return this.hasDetailsTarget ? this.detailsTarget : this.element
  }

  get #toggler() {
    return this.hasTogglerTarget ? this.togglerTarget : null
  }
}
